<template>
  <toggleSwitch2
    :title="$t('settings.autoConfirm.title')"
    :help="$t('settings.autoConfirm.info')"
    :value="data"
    :callback="setValue"
  />
</template>
<script>
export default {
  props: {},
  data() {
    return {
      data: this.$store.state.business.unsaved.autoconfirm
    };
  },
  methods: {
    setValue(val) {
      this.data = val;
      this.setSave();
    },
    setSave() {
      var data = JSON.parse(JSON.stringify(this.$store.state.business.unsaved));
      data.autoconfirm = this.data;
      this.$store.commit("business/prefetch", data);
    }
  }
};
</script>
<style lang="sass" scoped></style>
